import i18n from 'i18n/config'

export const forensicsStyles = {
  baseColorCustomization: {
    iconColor: 'var(--primary-color-middle, #4f9d3a)'
  },
  hintAnimation: {
    hideAnimation: true,
    hintGradientColor: 'transparent'
  },
  buttonCustomization: {
    backgroundColorPrimary: 'var(--primary-color-middle, #4f9d3a)'
  },
  centerHintCustomization: {
    textSize: '16px',
    textWeight: '400'
  },
  faceFrameCustomization: {
    strokeDefaultColor: 'var(--red-dark, #c24141)',
    strokeFaceInFrameColor: 'var(--primary-color-middle, #4f9d3a)'
  },
  antiscamCustomization: {
    enableAntiscam: true,
    textMessage: i18n.t('forensics-antiscam-text'),
    textSize: '20px',
    textColor: 'var(--red-dark, #c24141)'
  }
}

const forensicsActionsGroups = [
  ['video_selfie_eyes'],
  ['video_selfie_smile'],
  ['video_selfie_left', 'video_selfie_right']
]

export function getRandomForensicsActions() {
  const randomGroups = forensicsActionsGroups
    .slice()
    .sort(() => Math.random() - 0.5)
    .slice(0, 3)

  return ['video_selfie_scan', ...randomGroups.flat()]
}

export const forensicsParams = {
  extract_best_shot: true
}

export const forensicsResultMode = 'full'
